import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core'

export interface GoalCardProps {
  title: string
  description: any
  icon: IconName
  iconPrefix: IconPrefix
}

export const useGoalCard = (props: GoalCardProps) => {
  return {
    ...props,
  }
}
